<template>
  <div class="my_foot">
    <div class="foot-body">
      <div class="foot-top container">
        <div class="footer-section contact-info">
          <h3 class="section-title">{{ $t('footer.sections.contactInfo') }}</h3>
          <ul>
            <li>
              <div class="icon-text">
                <i class="fas fa-clock"></i>
                <span>{{ workTime }}</span>
              </div>
            </li>
            <li>
              <div class="icon-text">
                <i class="fas fa-envelope"></i>
                <span>{{ email }}</span>
              </div>
            </li>
            <li>
              <div class="icon-text">
                <i class="fas fa-phone"></i>
                <span>{{ phone }}</span>
              </div>
            </li>
            <li>
              <div class="icon-text">
                <i class="fas fa-globe"></i>
                <span>{{ webUrl }}</span>
              </div>
            </li>
            <li>
              <div class="icon-text">
                <i class="fas fa-map-marker-alt"></i>
                <span>{{ address }}</span>
              </div>
            </li>
          </ul>
        </div>

        <div class="footer-section products">
          <h3 class="section-title">{{ $t('footer.sections.products') }}</h3>
          <ul>
            <li v-for="(item, index) in cateNames.slice(0, 4)" :key="index" @click="linkOther(index+1)">
              <div class="icon-text">
                <i class="fas fa-angle-right"></i>
                <span>{{ item }}</span>
              </div>
            </li>
          </ul>
        </div>

        <div class="footer-section accessories">
          <h3 class="section-title">{{ $t('footer.sections.products') }}</h3>
          <ul>
            <li v-for="(item, index) in cateNames.slice(4, 8)" :key="index" @click="linkOther(index+5)">
              <div class="icon-text">
                <i class="fas fa-angle-right"></i>
                <span>{{ item }}</span>
              </div>
            </li>
          </ul>
        </div>

        <div class="footer-section company">
          <h3 class="section-title">{{ $t('footer.sections.company') }}</h3>
          <ul>
            <li>
              <div class="icon-text">
                <i class="fas fa-info-circle"></i>
                <span @click="linkAbout">{{ aboutUs }}</span>
              </div>
            </li>
            <li>
              <div class="icon-text">
                <i class="fas fa-users"></i>
                <span @click="linkContact">{{ contactUs }}</span>
              </div>
            </li>
            <li>
              <div class="icon-text">
                <i class="fas fa-list-alt"></i>
                <span @click="linkPdtList">{{ productCatalog }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="foot-bottom container">
        <div class="bottom-content">
        <span class="copyright">
          <h5>{{ $t('footer.copyright') }}</h5>
        </span>
          <div class="social-icons">

          </div>
          <span class="icp">
          <h5>浙ICP备2021007602号</h5>
        </span>
        </div>
      </div>
    </div>
    <el-backtop :right="40" :bottom="40" />
  </div>
</template>

<script>
export default {
  name: "MyFoot",
  computed: {
    // 联系信息
    workTime() {
      return this.$t('footer.contactInfo.workTime');
    },
    email() {
      return "General-M@y-signal.com";
    },
    phone() {
      return this.$t('footer.contactInfo.phone');
    },
    address() {
      return this.$t('footer.contactInfo.address');
    },
    webUrl() {
      return this.$t('footer.contactInfo.webUrl');
    },

    // 产品分类名称
    cateNames() {
      return [
        this.$t('categories.miniLightBars'),
        this.$t('categories.fullLightBars'),
        this.$t('categories.visorLightBars'),
        this.$t('categories.deckDashLights'),
        this.$t('categories.grilleSurfaceMounts'),
        this.$t('categories.siren'),
        this.$t('categories.trafficAdvisors'),
        this.$t('categories.mountingBrackets')
      ];
    },

    // 公司相关链接
    aboutUs() {
      return this.$t('footer.company.aboutUs');
    },
    contactUs() {
      return this.$t('footer.company.contactUs');
    },
    productCatalog() {
      return this.$t('footer.company.productCatalog');
    }
  },
  methods: {
    linkOther(categoryId) {
      this.$router.push({ name: 'PdtList', params: { categoryId } });
    },
    linkPdtList() {
      const fileUrl = "https://produclist.oss-cn-beijing.aliyuncs.com/mulu.pdf";
      window.open(fileUrl, "_blank"); // 新窗口打开
    },
    linkAbout() {
      this.$router.push({ name: 'aboutUs' });
    },
    linkContact() {
      this.$router.push({ name: 'contactUs' });
    }
  }
};
</script>

<style scoped>
/* 原有样式保持不变 */
.my_foot {
  background-color: gainsboro;
  color: #333333;
  border-top: 3px solid #e0e0e0;
  padding: 2rem 0 0 0; /* 移除左边 2rem，避免整体偏移 */
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  font-weight: bolder;
  margin-bottom: 0;
}

.container {
  max-width: 80%; /* 宽度占比90% */
  margin: 0 auto; /* 水平居中 */
  padding: 0 1rem;
}



.foot-top {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.foot-bottom {
  border-top: 1px solid #e0e0e0; /* 浅灰色分隔线 */
}

.bottom-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

/* 页脚区块样式 */
.footer-section {
  padding: 1rem;
  transition: all 0.3s ease;
  background-color: white; /* 白色背景 */
  border-radius: 8px; /* 圆角 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); /* 轻微阴影 */
}

.footer-section:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* 悬停时增强阴影 */
}

.section-title {
  color: #222222; /* 黑色标题 */
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 40px;
  height: 2px;
  background-color: #666666; /* 深灰色下划线 */
}

/* 列表样式 */
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

li {
  margin-bottom: 1rem;
}

.icon-text {
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.icon-text:hover {
  color: #1a73e8; /* 蓝色悬停效果 */
  transform: translateX(5px);
}

.icon-text i {
  margin-right: 0.75rem;
  width: 1.25rem;
  text-align: center;
  color: #666666; /* 深灰色图标 */
}
.icon-text:last-child{
  text-align: left;
}

/* 底部内容样式 */
.copyright, .icp {
  font-size: 0.875rem;
  color: #666666; /* 深灰色文本 */
}

.social-icons {
  display: flex;
  gap: 1rem;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-color: #e0e0e0; /* 浅灰色背景 */
  color: #666666; /* 深灰色图标 */
  transition: all 0.3s ease;
}

.social-icon:hover {
  background-color: #1a73e8; /* 蓝色悬停效果 */
  color: white;
  transform: translateY(-3px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .foot-top {
    grid-template-columns: repeat(2, 1fr);
  }

  .bottom-content {
    flex-direction: column;
    gap: 1rem;
  }
}

@media (max-width: 576px) {
  .foot-top {
    grid-template-columns: 1fr;
  }
}
</style>
